/** @jsxImportSource @emotion/react */
import isMobile from 'ismobilejs';
import { css } from '@emotion/react';
import { SystemAuthor } from './Message.Author';
import { usePlaceholderStyles } from './Message.System.styles';
import { useCallback } from 'react';
import { extendedMessageWidth, fullChatExtendedMessageWidth } from './Message.styles';
import { PlaceholderMessageSkeleton } from './Message.System.Placeholder';
import { AgentProgressTimeline } from '../Chat.AgentProgress/Timeline';
import { ChainOfThoughtSteps, useChainOfThoughtSteps } from './Message.System.ChainOfThought';
import { useIsFullPageChat } from './hooks/useIsFullPageChat';
import { useAgentProgressTimeline } from '../Chat.AgentProgress/useTimeline';

type Props = {};

export const SystemUserInFlightResponse = (props: Props) => {
  const device = isMobile();
  const styles = usePlaceholderStyles();

  const steps = useChainOfThoughtSteps();

  const timeline = useAgentProgressTimeline();

  const renderBody = useCallback(() => {
    if (timeline.length > 0) {
      return (
        <div>
          <AgentProgressTimeline nodes={timeline} />
        </div>
      );
    }

    if (steps.length > 0) {
      return <ChainOfThoughtSteps steps={steps} />;
    }

    return <PlaceholderMessageSkeleton />;
  }, [steps, timeline]);

  const isFullPageChat = useIsFullPageChat();

  const bodyWidth = (() => {
    if (timeline.length === 0) return undefined;
    return isFullPageChat ? fullChatExtendedMessageWidth : extendedMessageWidth;
  })();

  return (
    <div css={styles.root}>
      {!device.phone && (
        <div css={styles.authorWrap}>
          <SystemAuthor animate={true} css={styles.author} />
        </div>
      )}
      <div css={css({ maxWidth: bodyWidth, width: '100%' })}>
        <div css={css([styles.body, css({ maxWidth: bodyWidth, width: '100%' })])}>{renderBody()}</div>
      </div>
    </div>
  );
};
